// Inbound业务意向标签
export default {
  zh: {
    A: '询问下单',
    B: '不愿还款'
  },
  en: {
    A: 'xiadan',
    B: 'complaint'
  },
  ba: {
    A: 'xiadan',
    B: 'complaint'
  }
}



// WEBPACK FOOTER //
// ./src/utils/intentionTags/InboundTags.js